import { SignDocument } from "@/models/sign-document.entity";
import documentService from "@/services/sign/services/document.service";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { FetchStrategy, SharedContentDocument, safeFetch } from "../SharedContentFetchStrategy";

export class DocumentFetchStrategy implements FetchStrategy {
  canHandle(refType: string): boolean {
    return refType === ResourceEnum.DOCUMENT;
  }

  fetch(partnerId: string, refId: string, sct: string): Promise<SharedContentDocument> {
    return safeFetch(refId, ResourceEnum.DOCUMENT, async () => {
      return await documentService.getDocumentBySharedAccessToken(partnerId, refId, sct).then(v => new SignDocument(v));
    });
  }
}
